import axios from 'axios';
import * as process from 'process';

export const apiClient = axios.create({
  baseURL: process.env.REACT_APP_G360_API_URL,
  headers: {
    'Content-type': 'application/json',
  },
});
